module.exports = {
	siteName: 'feed',
	site: {
		mancity: {
			appI18nConfig: {
				defaultLocale: 'en',
				supportedLocales: ['en'],
			},
		},
	},
};
